import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'uc-course-information-table-row',
	templateUrl: './course-information-table-row.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgClass],
})
export class CourseInformationTableRowComponent {
	providerDetail = input.required<string>();
	data = input<string | null>();
	entryPoints = input<string[]>();
	customStyles = input<string>('');
}
